// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3MJgo","options":"AnswerScale_options__2Q-RW","selected":"AnswerScale_selected__3sy3A"};